import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  toggleButton: {
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  toggleButtonClosed: {
    transform: 'rotate(180deg)',
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
});

export default useStyles;
